/**
 * Created by sagardesai on 10/07/18.
 */

import {RSAA} from 'redux-api-middleware';
import {API_ENDPOINT, AUTH_HEADERS, X_AUTHORIZATION} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";


export function getFavouritesList(token, api_token, query, filter_by) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/favorites?api_token=${api_token}&filter_by=${filter_by}&query=${query}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FAVOURITES_LIST_REQUEST, types.FAVOURITES_LIST_RECEIVE, {
                type: types.FAVOURITES_LIST_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetFavouritesList = () => ({
    type: types.RESET_FAVOURITES_LIST,
    payload: null
});

export function favouriteViewer(token, api_token, user_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/favorite/user/${user_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FAVOURITE_UNFAVOURITE_VIEWER_REQUEST, types.FAVOURITE_UNFAVOURITE_VIEWER_RECEIVE, {
                type: types.FAVOURITE_UNFAVOURITE_VIEWER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}


export function unFavouriteViewer(token, api_token, user_id) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/unfavorite/user/${user_id}?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.FAVOURITE_UNFAVOURITE_VIEWER_REQUEST, types.FAVOURITE_UNFAVOURITE_VIEWER_RECEIVE, {
                type: types.FAVOURITE_UNFAVOURITE_VIEWER_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetFavouritesUnFavouriteData = () => ({
    type: types.RESET_FAVOURITE_UNFAVOURITE_VIEWER,
    payload: null
});

export const setSearchFavouritesState = (state) => ({
    type: types.SET_SEARCH_FAVOURITES_STATE,
    payload: state
});

